import { useState } from 'react';
import Sidebar from './Sidebar';
import { Route, Switch } from 'react-router-dom';
import LoggedUserCard from './LoggedUserCard';
import Clients from '../modules/Clients/Clients';
import Products from '../modules/Products/Products';
import Utilisateurs from '../modules/Users/Utilisateurs';
import ClientDetails from '../modules/Clients/ClientDetails';
import Purchases from '../modules/Purchases/Purchases';
import ModuleWrapper from '../components/ModuleWrapper';
import Brands from '../modules/Brands/Brands';
import Families from '../modules/Families/Families';
import Orders from '../modules/Orders/Orders';
import OrderDetails from '../modules/Orders/OrderDetails';
import GlobalSearch from './GlobalSearch';
import Repositories from '../modules/Repo/Repositories';
import Providers from '../modules/Repo/Providers';
import ProductsByRepo from '../modules/Repo/ProductsByRepo';
import Transfers from '../modules/Repo/Transfers';
import TransferRequests from '../modules/Repo/TransferRequests';
import ExtraFields from '../modules/Fields/ExtraFields';
import Dashboard from '../modules/Dashboard/Dashboard';
import DeliveryNotes from '../modules/DeliveryNotes/DeliveryNotes';
import DeliveryNoteDetails from '../modules/DeliveryNotes/DeliveryNoteDetails';
import QuoteDetails from '../modules/Quotes/QuoteDetails';
import CreditNotes from '../modules/CreditNotes/CreditNotes';
import CreditNoteDetails from '../modules/CreditNotes/CreditNoteDetails';
import Invoices from '../modules/Invoices/Invoices';
import InvoiceDetails from '../modules/Invoices/InvoiceDetails';
import Payments from '../modules/Recouvrement/Payments';
import InfosFinanciers from '../modules/Recouvrement/InfosFinanciers';
import Expenses from '../modules/Performance/Expences';
import Quotes from '../modules/Quotes/Quotes';
import AvoirFinanciers from '../modules/AvoirFinanciers/AvoirFinanciers';
import AvoirFournisseurs from '../modules/AvoirFournisseurs/AvoirFournisseurs';
import AvoirFinancierDetails from '../modules/AvoirFinanciers/AvoirFinancierDetails';
import AvoirFournisseursDetails from '../modules/AvoirFournisseurs/AvoirFournisseursDetails';
import ExpenseDetails from '../modules/Performance/ExpenseDetails';
import PaymentsDetails from '../modules/Recouvrement/PaymentsDetails';
import SnackbarNotification from '../components/SnackbarNotification';
import Banks from '../modules/Banks/Banks';
import PaymentTypes from '../modules/PaymentTypes/PaymentsTypes';
import { useHistory } from "react-router-dom";

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Layout = () => {
  const layoutStyle = {
    display: 'flex',
    height: '100vh',
    overflowX: 'hidden',
  };

  const blurStyle = {
    position: 'absolute',
    width: '100%',
    height: '150px',
    background: '#6379F5',
    opacity: 0.15,
    filter: 'blur(50px)',
    zIndex: 0,
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '20px 40px',
    gap: '10px',
    zIndex: 1000,
    flexWrap: 'nowrap',
    position: 'sticky',
  };

  const contentStyle = {
    padding: '20px 40px 20px 40px',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    position: 'relative',
    maxWidth: '100vw',
  };

  const history = useHistory();
  const location = useLocation();

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const showSnackbar = (message, severity = 'success', manual = false) => {
    setSnackbar({ open: true, message, severity, manual });
  };

  useEffect(() => {
    if (location.state?.showSnackbar) {
      showSnackbar(location.state.snackbarMessage, location.state.snackbarSeverity);
      history.replace({ ...location, state: undefined });
    }
  }, [location, history]);


  return (
    <div style={layoutStyle}>
      <div style={blurStyle}></div>
      <div className="absolute bottom-0 left-20 h-full w-1/2 bg-cover bg-center  z-[-100]"
        style={{ backgroundImage: `url(${require('../images/background.png')})`, backgroundSize: "cover", backgroundPosition: "center" }}>
      </div>
      <div style={{
        flex: '0 0 auto',
        width: '25%',
        minWidth: '220px',
        maxWidth: '270px'
      }}>        
      <Sidebar />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflowX: 'hidden' }}>
        <div style={headerStyle}>
          <GlobalSearch />
          {/* <ExportButton /> */}
          <LoggedUserCard />
        </div>
        {/* Content */}
        <div style={contentStyle}>
          <Switch>

            <Route path="/" exact component={Dashboard} />
            <Route path="/catalog/brands" component={Brands} />
            <Route path="/catalog/families" component={Families} />
            <Route path="/catalog/products" component={Products} />

            <Route
              path="/clients/add"
              render={(props) => <ModuleWrapper {...props} moduleType="clients" />}
            />
            <Route
              path="/clients/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="clients" mode="modify" />}
            />
            <Route
              path="/clients/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="clients" mode="modify" />}
            />
            <Route path="/clients/details/:id" component={ClientDetails} />
            <Route path="/clients" component={Clients} />

            <Route
              path="/purchases/add"
              render={(props) => <ModuleWrapper {...props} moduleType="purchases" />}
            />
            <Route path="/purchases" component={Purchases} />

            <Route
              path="/quotes/add"
              render={(props) => <ModuleWrapper {...props} moduleType="quotes" />}
            />
            <Route
              path="/quotes/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="quotes" mode="modify" />}
            />
            <Route
              path="/quotes/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="quotes" mode="modify" />}
            />
            <Route path="/quotes/details/:id" component={QuoteDetails} />
            <Route path="/quotes" component={Quotes} />

            <Route
              path="/orders/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="orders" mode="modify" />}
            />
            <Route path="/orders/details/:id" component={OrderDetails} />
            <Route
              path="/orders/add"
              render={(props) => <ModuleWrapper {...props} moduleType="orders" />}
            />
            <Route
              path="/orders/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="orders" mode="modify" />}
            />
            <Route path="/orders" component={Orders} />

            <Route path="/delivery-notes/details/:id" component={DeliveryNoteDetails} />
            <Route path="/delivery-notes" component={DeliveryNotes} />

            <Route path="/invoices/details/:id" component={InvoiceDetails} exact />
            <Route path="/invoices" component={Invoices} exact />

            <Route
              path="/credit-notes/add"
              render={(props) => <ModuleWrapper {...props} moduleType="creditNotes" />}
            />
            <Route path="/credit-notes/details/:id" component={CreditNoteDetails} exact />
            <Route path="/credit-notes" component={CreditNotes} exact />
            <Route
              path="/avoirs-financiers/add"
              render={(props) => <ModuleWrapper {...props} moduleType="afinancier" />}
            />
            <Route
              path="/avoirs-financiers/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="afinancier" mode="modify" />}
            />
            <Route path="/avoirs-financiers/details/:id" component={AvoirFinancierDetails} />
            <Route path="/avoirs-financiers" component={AvoirFinanciers} exact />

            <Route
              path="/avoirs-fournisseurs/add"
              render={(props) => <ModuleWrapper {...props} moduleType="afournisseur" />}
            />
            <Route
              path="/avoirs-fournisseurs/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="afournisseur" mode="modify" />}
            />
            <Route path="/avoirs-fournisseurs/details/:id" component={AvoirFournisseursDetails} />
            <Route path="/avoirs-fournisseurs" component={AvoirFournisseurs} exact />

            <Route
              path="/payments/add"
              render={(props) => <ModuleWrapper {...props} moduleType="payments" />}
            />
            <Route
              path="/payments/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="payments" mode="modify" />}
            />
            <Route
              path="/payments/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="payments" mode="modify" />}
            />
            <Route path="/payments/details/:id" component={PaymentsDetails} exact />
            <Route path="/payments" component={Payments} exact />
            <Route path="/infos-financiers" component={InfosFinanciers} exact />

            <Route
              path="/expenses/add"
              render={(props) => <ModuleWrapper {...props} moduleType="expenses" />}
            />
            <Route
              path="/expenses/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="expenses" mode="modify" />}
            />
            <Route
              path="/expenses/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="expenses" mode="modify" />}
            />
            <Route path="/expenses/details/:id" component={ExpenseDetails} exact />
            <Route path="/expenses" component={Expenses} exact />

            <Route path="/products-by-repo" component={ProductsByRepo} />
            <Route path="/transfers/history" component={Transfers} />
            <Route
              path="/transfer-requests/add"
              render={(props) => <ModuleWrapper {...props} moduleType="requests" />}
            />

            <Route
              path="/transfer-requests/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="requests" mode="modify" />}
            />
            <Route path="/transfer-requests" component={TransferRequests} />

            <Route path="/repos" component={Repositories} />

            <Route path="/providers" component={Providers} />

            <Route path="/users" component={Utilisateurs} />
            <Route path="/fields" component={ExtraFields} />
            <Route path="/banks" component={Banks} />
            <Route path="/payment-types" component={PaymentTypes} />
          </Switch>
        </div>
      </div>

      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        manual={snackbar.manual}
      />
    </div>
  );
};

export default Layout;
